const Department = {
    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "department": "القسم",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_status": "الرجاء اختيار الحالة",

    // TABLE HEADERF
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_status": "الحالة",

};

export default Department;
